import React from "react"
import { connect } from "react-redux"
import { push } from "connected-react-router"
import PropTypes from "prop-types"
import Map from 'pigeon-maps'
import Overlay from 'pigeon-overlay'
import { Search } from "react-feather"

import {Toast} from "react-weui"
import MyMarker from './MyMarker'
import { getZoom, getRegionForCoordinates } from "../transportation"

class PigeonMap extends React.Component {
  constructor(props) {
    super(props)
    this.state = { 
      directions: '',
      bounds: ''
    }
  }

  componentDidMount() {
    const {originCoords, destinationCoords} = this.props
    if (originCoords && destinationCoords) this.getDirectionsData(originCoords, destinationCoords)
    else if (originCoords) this.setPanTo(originCoords)
    else if (destinationCoords) this.setPanTo(destinationCoords)
  }

  componentDidUpdate(prevProps, _prevState, _snapshot) {
    const {originCoords, destinationCoords} = this.props

    if (originCoords && destinationCoords && (originCoords != prevProps.originCoords ||  destinationCoords != prevProps.destinationCoords)) this.getDirectionsData(originCoords, destinationCoords)
    else if (originCoords != prevProps.originCoords) this.setPanTo(originCoords)
    else if (destinationCoords != prevProps.destinationCoords) this.setPanTo(destinationCoords)
  }

  setPanTo(coords) {
    const panTo = {lat: coords[0], lng: coords[1]}
    this.setState({panTo})
  }


  getMapCenter() {
    const {originCoords, destinationCoords, city} = this.props
    if (originCoords && destinationCoords) return getRegionForCoordinates([originCoords, destinationCoords]).latlng
    else if (originCoords) return originCoords
    else if (destinationCoords) return destinationCoords
    else if (this.props.cities[city]) return [this.props.cities[city].preciseLocation.latitude, this.props.cities[city].preciseLocation.longitude]
    else return [this.props.cities.Madrid.preciseLocation.latitude, this.props.cities.Madrid.preciseLocation.longitude]
  }
  
  getMapZoom() {
    const {originCoords, destinationCoords} = this.props
    if (originCoords && destinationCoords) {
      return getZoom(originCoords, destinationCoords)
    }
    else return originCoords ? 16.5 : 11.5
  }

  render() {
    const pigeonMap = (
      <Map
        center={this.getMapCenter()}
        zoom={this.getMapZoom()}
        minZoom={this.getMapZoom()}
        maxZoom={this.getMapZoom()}
        touchEvents={false}
        height={this.props.height}
      >
        {                  
          this.props.originCoords && (
            <MyMarker anchor={this.props.originCoords} payload={1}/>
          )
        }
        {
          this.props.destinationCoords && (
            <MyMarker anchor={this.props.destinationCoords} payload={2}/>
          )
        }                
        {
          this.props.fetchingCoords && (
            <Overlay anchor={this.getMapCenter()} offset={[0, 250]}>
              <Toast icon="loading" show>Loading...</Toast>
            </Overlay>
          )
        }
        {this.props.searchBox && (
          <div className="search-container" 
            onClick={() => {
              this.props.push(`/catalogo/${this.props.city}/transportation?step=searchDestination`)
            }}
          >
            <div className="field" >
              <div className="white">
                <div className="text">Busca su destino ...</div>
                <div className="icon search">
                  <Search />
                </div>
              </div>
            </div>
          </div>
        )}
        
        
      </Map>
    )

    return pigeonMap
  }
}

PigeonMap.propTypes = {
  originCoords: PropTypes.array.isRequired,
  destinationCoords: PropTypes.array.isRequired,
  city: PropTypes.string.isRequired,
  fetchingCoords: PropTypes.bool.isRequired,
  cities:PropTypes.string.isRequired,
  disableDragging: PropTypes.bool
}

PigeonMap.defaultProps = {
  disableDragging: false
}

const mapStateToProps = (state, ownProps) => ({})


const mapDispatchToProps = (dispatch, _ownProps) => ({
  push: (url) => dispatch(push(url)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PigeonMap)


// WEBPACK FOOTER //
// ./src/app/catalogo/transportation/components/PigeonMap.jsx